<template>
  <div :class="['menu', show ? 'show-active' : '']">
    <div
      class="icon1"
      :class="{ unactive: MenuShadow }"
      :style="{ zIndex: showDocMenu ? 1 : 9999 }"
    >
      <div class="headerLeft">
        <router-link class="headerLink" to="/home"
          ><img src="@/assets/menu/logo.svg" alt=""
        /></router-link>
        <a
          class="headerAnc"
          :href="cgInfo.nav_announcement_url"
          v-if="
            this.$route.path == '/home' &&
            cgInfo &&
            Number(cgInfo.nav_announcement_btn) !== -1
          "
        >
          <img class="headerAncImg" src="@/assets/menu/lp.svg" alt="" />
          <span class="headerAncText">官网公告</span>
        </a>
        <div
          class="mentionboad"
          @click="closeAnPop"
          v-if="
            $route.path == '/home' &&
            cgInfo &&
            Number(cgInfo.nav_announcement_btn) === 2 &&
            showAnPop
          "
        >
          <BulletinBoard @closeAnPop="closeAnPop" :BulletinBoardUrl="cgInfo.nav_announcement_url" />
        </div>

      </div>
      <div class="icon-1">
        <a href="https://uc.todesk.com/mobile/dashboard" v-show="!show" style="margin-right: 20px;margin-top:1px;">
          <svg class="login-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5826 8.5C17.5826 11.5376 15.1202 14 12.0826 14C9.04507 14 6.58264 11.5376 6.58264 8.5C6.58264 5.46243 9.04507 3 12.0826 3C15.1202 3 17.5826 5.46243 17.5826 8.5ZM16.0826 8.5C16.0826 10.7091 14.2918 12.5 12.0826 12.5C9.8735 12.5 8.08264 10.7091 8.08264 8.5C8.08264 6.29086 9.8735 4.5 12.0826 4.5C14.2918 4.5 16.0826 6.29086 16.0826 8.5Z" fill="#585F69"/>
            <path d="M4.16528 20.4723C5.99881 18.2102 8.8598 16.75 12.0826 16.75C15.3055 16.75 18.1665 18.2102 20 20.4723L21.1653 19.5277C19.0517 16.9201 15.7653 15.25 12.0826 15.25C8.40002 15.25 5.1136 16.9201 3 19.5277L4.16528 20.4723Z" fill="#585F69"/>
          </svg>
        </a>
        <img src="@/assets/menu/nav.svg" @click="open" v-show="!show" alt="" />
        <div class="close" @click="close" v-show="show">
          <img src="@/assets/menu/navclose.svg" alt="" />
        </div>
      </div>
    </div>
    <div
      class="mask nav-active"
      v-show="show"
    >
      <div class="mask_bx">
      <div class="link_item">
        <div class="link_click_wrap" @click="close">
          <router-link
            to="/home"
            class="link_lable"
            :class="{ active: $route.path == '/home' }"
          >
            <span>首页</span>
          </router-link>
        </div>
      </div>
      <div class="link_item">
        <div class="link_lable" @click="handleFlodItem('showProd')">
          <span>远控控制</span>
          <svg :style="showProd ? '' : 'transform: rotate(180deg);'" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.2729 9.55225L13.3436 9.48154L13.2729 9.41083L7.70439 3.84236C7.48465 3.62262 7.14219 3.60076 6.89789 3.77654L6.8977 3.77627L6.8915 3.78155L6.82643 3.8369L6.82621 3.83665L6.82051 3.84236L1.25204 9.41083L1.18133 9.48154L1.25204 9.55225L1.99451 10.2947L2.06522 10.3654L2.13593 10.2947L7.26186 5.16877L12.389 10.2947L12.4597 10.3654L12.5304 10.2947L13.2729 9.55225Z" fill="#616369" stroke="#616369" stroke-width="0.2"/>
          </svg>
        </div>
        <div class="fold_item" :class="showProd ? 'active' : ''">
          <router-link
            class="fold_item_link toc_wrap"
            to="/solo"
            :class="{ active: $route.path == '/solo' }"
          >
            <div @click="close" class="item_name personal">
              <img src="@/assets/menu/solo@2x.png" alt="" />
              <span>了解ToDesk个人版</span>
              <svg class="arror_right" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.4469 13.2729L4.51761 13.3436L4.58832 13.2729L10.1568 7.70445C10.3765 7.48471 10.3984 7.14225 10.2226 6.89795L10.2229 6.89776L10.2176 6.89156L10.1622 6.82649L10.1625 6.82628L10.1568 6.82057L4.58832 1.2521L4.51761 1.18139L4.4469 1.2521L3.70444 1.99457L3.63373 2.06528L3.70444 2.13599L8.83037 7.26193L3.70443 12.389L3.63373 12.4598L3.70444 12.5305L4.4469 13.2729Z" fill="#616369" stroke="#616369" stroke-width="0.2"/>
              </svg>
            </div>
          </router-link>
          <p class="fold_item_subTitle toc">超值服务</p>
          <router-link
            class="fold_item_link toc_wrap"
            to="/perform"
            :class="{ active: $route.path == '/game' }"
          >
            <div @click="close" class="item_name height57">
              <img src="@/assets/menu/perform-v2.png" alt="" />
              <span>性能版</span>
            </div>
          </router-link>
          <router-link
            class="fold_item_link toc_wrap"
            to="/game"
            :class="{ active: $route.path == '/game' }"
          >
            <div @click="close" class="item_name height57">
              <img src="@/assets/menu/game-v2.png" alt="" />
              <span>游戏版</span>
            </div>
          </router-link>
          <router-link
            class="fold_item_link toc_wrap"
            to="/solo"
            :class="{ active: $route.path == '/solo' }"
          >
            <div @click="close" class="item_name height57">
              <img src="@/assets/menu/pro-v2.png" alt="" />
              <span>专业版</span>
            </div>
          </router-link>
          <div class="transverse-line"></div>
          <router-link
            class="fold_item_link tob_wrap foid_enterprise"
            to="/enterprise"
            :class="{ active: $route.path == '/solo' }"
          >
            <div @click="close" class="item_name enterprise">
              <img src="@/assets/menu/ep@2x.png" alt="" />
              <span>了解ToDesk企业版</span>
              <svg class="arror_right" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.4469 13.2729L4.51761 13.3436L4.58832 13.2729L10.1568 7.70445C10.3765 7.48471 10.3984 7.14225 10.2226 6.89795L10.2229 6.89776L10.2176 6.89156L10.1622 6.82649L10.1625 6.82628L10.1568 6.82057L4.58832 1.2521L4.51761 1.18139L4.4469 1.2521L3.70444 1.99457L3.63373 2.06528L3.70444 2.13599L8.83037 7.26193L3.70443 12.389L3.63373 12.4598L3.70444 12.5305L4.4469 13.2729Z" fill="#616369" stroke="#616369" stroke-width="0.2"/>
              </svg>
            </div>
          </router-link>
          <p class="fold_item_subTitle tob">解决方案</p>
          <router-link
            class="fold_item_link tob_wrap"
            to="/solutions/design"
            :class="{ active: $route.path == '/solutions/design' }"
          >
            <div @click="close" class="item_name">
              <img src="@/assets/menu/gaoxingneng-v2.png" alt="" />
              <span>高性能办公</span>
            </div>
          </router-link>
          <router-link
            class="fold_item_link tob_wrap"
            to="/solutions/telework"
            :class="{ active: $route.path == '/solutions/telework' }"
          >
            <div @click="close" class="item_name">
              <img src="@/assets/menu/yuancheng-v2.png" alt="" />
              <span>远程安全办公</span>
            </div>
          </router-link>
          <router-link
            class="fold_item_link tob_wrap"
            to="/solutions/localization"
            :class="{ active: $route.path == '/solutions/localization' }"
          >
            <div @click="close" class="item_name">
              <img src="@/assets/menu/xinchuang-v2.png" alt="" />
              <span>信创方案</span>
            </div>
          </router-link>
          <router-link
            class="fold_item_link tob_wrap"
            to="/solutions/remoteSupport"
            :class="{ active: $route.path == '/solutions/remoteSupport' }"
          >
            <div @click="close" class="item_name">
              <img src="@/assets/menu/jishu-v2.png" alt="" />
              <span>技术支持</span>
            </div>
          </router-link>
        </div>
      </div>
      <div class="link_item">
        <div class="link_lable" @click="handleFlodItem('showDesktron')">
          <span
            :class="{ active: $route.path == '/desktron' }"
          >
            <span class="icon-inline">
              云电脑
              <svg width="34" height="16" viewBox="0 0 34 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 8C0 3.58172 3.58172 0 8 0H26C30.4183 0 34 3.58172 34 8C34 12.4183 30.4183 16 26 16H0V8Z" fill="url(#paint0_linear_4696_3539)"/>
                <path d="M18.5312 4.31738H19.9966L21.4841 10.3451H21.5285L23.0937 4.31738H24.4369L26.0021 10.3451H26.0465L27.534 4.31738H28.9993L26.7126 12.2434H25.3361L23.793 6.28223H23.7486L22.1945 12.2434H20.8069L18.5312 4.31738Z" fill="white"/>
                <path d="M12.1296 4.31738H17.8466V5.42747H13.4284V7.62543H17.5802V8.73552H13.4284V11.1333H18.0353V12.2434H12.1296V4.31738Z" fill="white"/>
                <path d="M4 4.31738H5.2988L9.21739 10.0343H9.2618V4.31738H10.5717V12.2434H9.3062L5.3432 6.44874H5.2988V12.2434H4V4.31738Z" fill="white"/>
                <defs>
                <linearGradient id="paint0_linear_4696_3539" x1="34" y1="8" x2="-2" y2="8" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF771C"/>
                <stop offset="1" stop-color="#FF961C"/>
                </linearGradient>
                </defs>
              </svg>
            </span>
          </span>
          <svg
            :style="showDesktron ? '' : 'transform: rotate(180deg);'"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.2729 9.55225L13.3436 9.48154L13.2729 9.41083L7.70439 3.84236C7.48465 3.62262 7.14219 3.60076 6.89789 3.77654L6.8977 3.77627L6.8915 3.78155L6.82643 3.8369L6.82621 3.83665L6.82051 3.84236L1.25204 9.41083L1.18133 9.48154L1.25204 9.55225L1.99451 10.2947L2.06522 10.3654L2.13593 10.2947L7.26186 5.16877L12.389 10.2947L12.4597 10.3654L12.5304 10.2947L13.2729 9.55225Z"
              fill="#616369"
              stroke="#616369"
              stroke-width="0.2"
            />
          </svg>
        </div>
        <div class="fold_item" :class="showDesktron ? 'active' : ''">
          <a
            class="fold_item_link toc_wrap"
            :href="_daas_www_hostName"
          >
            <div @click="close" class="item_name height58">
              <img src="@/assets/menu/down_logo.png" alt="" />
              <span>云电脑个人版</span>
              <p class="item_desc">超高算力，超清画质，感受云端魅力</p>
            </div>
          </a>
          <router-link
            class="fold_item_link toc_wrap"
            to="/desktron"
          >
            <div @click="close" class="item_name height57">
              <img src="@/assets/menu/desktron.png" alt="" />
              <span>云电脑企业版</span>
              <p class="item_desc">极致性能，高效运维，保障企业信息安全</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="link_item">
        <a
          class="fold_item_link dl_wrap"
          href="https://www.3dgali.com/"
        >
          <div @click="close" class="link_lable">
            <span class="icon-inline">云渲染</span>
          </div>
        </a>
      </div>
      <div class="link_item">
        <div class="link_lable" @click="handleFlodItem('showDl')">
          <span>下载</span>
          <svg :style="showDl ? '' : 'transform: rotate(180deg);'" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.2729 9.55225L13.3436 9.48154L13.2729 9.41083L7.70439 3.84236C7.48465 3.62262 7.14219 3.60076 6.89789 3.77654L6.8977 3.77627L6.8915 3.78155L6.82643 3.8369L6.82621 3.83665L6.82051 3.84236L1.25204 9.41083L1.18133 9.48154L1.25204 9.55225L1.99451 10.2947L2.06522 10.3654L2.13593 10.2947L7.26186 5.16877L12.389 10.2947L12.4597 10.3654L12.5304 10.2947L13.2729 9.55225Z" fill="#616369" stroke="#616369" stroke-width="0.2"/>
          </svg>
        </div>
        <div class="fold_item" :class="showDl ? 'active' : ''">
          <router-link
            class="fold_item_link dl_wrap"
            to="/download"
            :class="{ active: $route.path == '/download' }"
          >
            <div @click="close" class="item_name">
              <img src="@/assets/menu/solo@2x.png" alt="" />
              <span>下载个人版</span>
            </div>
          </router-link>
          <a
            class="fold_item_link dl_wrap"
            href="https://enterprise.todesk.com/download"
          >
            <div @click="close" class="item_name">
              <img src="@/assets/menu/ep@2x.png" alt="" />
              <span>下载企业版</span>
            </div>
          </a>
          <a
            class="fold_item_link dl_wrap"
            :href="`${_daas_www_hostName}/download`"
          >
            <div @click="close" class="item_name daas">
              <img src="@/assets/menu/daas@2x.png" alt="" />
              <span>下载云电脑</span>
            </div>
          </a>
        </div>
      </div>
      <div class="link_item">
        <div class="link_click_wrap" @click="close">
          <router-link
            class="link_lable"
            to="/pricing_individual.html"
            :class="{ active: $route.path == '/pricing_individual.html' }"
          >
            <span>定价</span>
          </router-link>
        </div>
      </div>
      <div class="link_item">
        <div class="link_click_wrap" @click="close">
          <router-link
            class="link_lable"
            to="/helpcenter"
            :class="{ active: $route.path == '/helpcenter' }"
          >
            <span>帮助中心</span>
          </router-link>
        </div>
      </div>
      <div class="link_item">
        <div class="link_click_wrap" @click="close">
          <router-link
            class="link_lable"
            to="/resourceCenter"
            :class="{ active: $route.path == '/resourceCenter' }"
          >
            <span>成功案例</span>
          </router-link>
        </div>
      </div>
      <div class="link_item">
        <a
          class="link_lable"
          href="https://enterprise.todesk.com/partner"
        >
          <span>代理商招募</span>
        </a>
      </div>
      <div class="link_item">
        <div class="link_lable" @click="handleFlodItem('showAbout')">
          <span>关于我们</span>
          <svg :style="showAbout ? '' : 'transform: rotate(180deg);'" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.2729 9.55225L13.3436 9.48154L13.2729 9.41083L7.70439 3.84236C7.48465 3.62262 7.14219 3.60076 6.89789 3.77654L6.8977 3.77627L6.8915 3.78155L6.82643 3.8369L6.82621 3.83665L6.82051 3.84236L1.25204 9.41083L1.18133 9.48154L1.25204 9.55225L1.99451 10.2947L2.06522 10.3654L2.13593 10.2947L7.26186 5.16877L12.389 10.2947L12.4597 10.3654L12.5304 10.2947L13.2729 9.55225Z" fill="#616369" stroke="#616369" stroke-width="0.2"/>
          </svg>
        </div>
        <div class="fold_item" :class="showAbout ? 'active' : ''">
          <router-link
            class="fold_item_link dl_wrap"
            to="/contact_us"
            :class="{ active: $route.path == '/contact_us' }"
          >
            <div @click="close" class="item_name">
              <img src="@/assets/menu/guanyu.png" alt="" />
              <span>关于ToDesk</span>
            </div>
          </router-link>
          <router-link
            class="fold_item_link dl_wrap"
            to="/join"
            :class="{ active: ($route.path == '/join' || $route.path == '/join/detail') }"
          >
            <div @click="close" class="item_name">
              <img src="@/assets/menu/jiaru.png" alt="" />
              <span>加入我们</span>
            </div>
          </router-link>
        </div>
      </div>
      <a class="gotoLogin" href="https://uc.todesk.com/mobile/dashboard">
        <div class="button-wrap">立即登录</div>
      </a>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import BulletinBoard from "../components/Common/BulletinBoard.vue";
export default {
  props: {
    showDocMenu: {
      type: Boolean,
      default: false,
    },
    cgInfo: {
      type: Object,
      default: null,
    },
  },
  components: {
    BulletinBoard,
  },
  data() {
    return {
      show: false,
      showProd: true,
      showSl: false,
      showDl: false,
      showAnPop: true,
      showAbout: false,
      showDesktron: false,
      announcementCtrl: -1,
      BulletinBoardUrl: '/news/683',
    };
  },
  created() {

  },
  watch: {
    cgInfo(n, o) {
      if (n && n.nav_announcement_btn != 1) {
        // localStorage.removeItem("showAnPop");
      }
    },
    show: {
      handler(val) {
        if (val) {
          document.body.classList.add('scrollForbiden')
        } else {
          document.body.classList.remove('scrollForbiden')
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState(["MenuShadow"]),
    jlink() {
      let _res = "";
      if (this.cgInfo) {
        try {
          let _i1 = this.cgInfo.nav_announcement_url.split("/news/")[1];
          _i1 = _i1.split(".html")[0];
          _res = "/news/" + _i1;
        } catch (error) {
          console.log(error);
        }
      }
      return _res;
    },
  },
  methods: {
    open() {
      this.show = !this.show;
    },
    close() {
      this.show = !this.show;
    },
    closeAnPop() {
      this.showAnPop = false;
      localStorage.setItem("showAnPop2", false);
    },
    handleFlodItem(key) {
      this[key] = !this[key]
    },
  },
  mounted() {
    if (localStorage.getItem("showAnPop2") === 'false') {
      this.showAnPop = false;
    }
    const menuStatusObj = JSON.parse(sessionStorage.getItem('menuStatusObj')) || null
    if (menuStatusObj) {
      this.showProd = menuStatusObj?.showProd || false
      this.showSl = menuStatusObj?.showSl || false
      this.showDl = menuStatusObj?.showDl || false
      this.showAbout = menuStatusObj?.showAbout || false
    }
  },
  beforeDestroy () {
    sessionStorage.setItem('menuStatusObj', JSON.stringify({
      showProd: this.showProd,
      showSl: this.showSl,
      showDl: this.showDl,
      showAbout: this.showAbout,
    }))
  },
 };
</script>
<style scoped lang="less">
.menu {
  position: fixed;
  top: 0;
  height: 50px;
  width: 100%;
  z-index: 9999;
  &.show-active {
    height: 100vh;
    max-height: 100vh;
    display: flex;
    flex-direction: column;
  }
}
.nav-active {
  .router-link-active {
    // background: rgba(0, 0, 0, 0.06);
  }
}
.mask {
  flex: 1;
  background: white;
  width: 100%;
  height: 100%;
}
.mask_bx{
  width: 100%;
  height: 100%;
  position: fixed;
  box-sizing: border-box;
  padding-bottom: 20vh;
  top: 50px;
  left: 0;
  z-index: 991;
  display: flex;
  flex-flow: column;
  overflow: auto;
  background: #fff;
}
.mask a.active {
  // background: rgba(0, 0, 0, 0.06);
}
.mask p {
  margin-top: 43px;
  text-align: center;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #141c40;
}
.close {
  width: 60px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.close > img {
  width: 24px;
  height: 24px;
}
.icon1 {
  display: flex;
  justify-content: space-between;
  background: white;
  height: 50px;
  width: 100%;
  align-items: center;
  z-index: 9999;
  &.unactive {
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.06);
  }
  .headerLeft {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: space-between;
    .headerLink {
      width: 107px;
      height: 34px;
    }
    .headerLink img {
      width: 100%;
      height: 100%;
      margin-left: 14px;
    }
    .headerAnc {
      display: flex;
      align-items: center;
      margin-right: 20px;
      height: 40px;
      .headerAncImg {
        width: 20px;
        height: auto;
      }
      .headerAncText {
        font-size: 15px;
        color: #585f69;
        margin-left: 5px;
      }
    }
  }
}

.icon-1 {
  height: 100%;
  display: flex;
  align-items: center;
  .login-svg {
    width: 24px;
    height: 24px;
    margin-top: 4px;
  }
}
.icon-1 > img {
  width: 24px;
  height: 24px;
  margin-right: 18px;
}
.fold_item {
  height: 0;
  overflow: hidden;
  padding-left: 24px;
  padding-right: 24px;
  .fold_item_subTitle {
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: 400;
    line-height: normal;
    text-align: left;
    margin-top: 24px;
    padding-bottom: 4px;
    &.toc {
      color: #FF6600;
    }
    &.tob {
      color: #747576;
    }
  }
  .transverse-line {
    height: 1px;
    width: 100%;
    background: #20253312;
    margin-top: 16px;
  }
}
.fold_item.active {
  height: auto;
  margin-bottom: 20px;
}
.link_item {
  &.lastItem {
    margin-bottom: 92px;
  }
}
.link_lable {
  padding: 10px 24px;
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // &.active {
  //   span {
  //     color: #0070f9;
  //   }
  // }
  span {
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    letter-spacing: 0px;
  }
  .icon-inline {
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      display: block;
      margin-left: 7px;
      align-self: flex-start;
    }
  }
  img {
    margin-left: 8px;
    width: 9px;
    height: auto;
  }
}
.fold_item_link {
  display: block;
  height: auto;
  &.foid_enterprise,
  &:first-of-type {
    margin-top: 16px;
  }
  &.active {
    span {
      color: #0070f9;
    }
  }
  &.toc_wrap, &.tob_wrap, &.dl_wrap {
    .item_name {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      box-sizing: border-box;
      height: 30px;
      padding: 6px 0;
      margin-top: 8px;
      &.personal {
        span {
          margin-left: 8px;
        }
      }
      &.enterprise {
        // padding-top: 16px;
        span {
          margin-left: 8px;
        }
      }
      &.height57 {
        box-sizing: border-box;
        height: 30px;
        padding: 6px 0;
        margin-top: 8px;
      }
      &.daas {
        img {
          width: 20px;
          height: auto;
        }
      }
      &.height58 {
        box-sizing: border-box;
        height: 58px;
        padding: 6px 0;
        margin-top: 8px;
      }
      img {
        height: 20px;
        width: auto;
      }
      span {
        margin-left: 8px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #25292f;
      }
      .arror_right {
        margin-left: 6.4px;
      }
      .item_desc {
        width: 100%;
        color:#747576;
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
        text-align: left;
        padding-left: 22px;
        margin-top: 4px;
      }
    }
  }
  &.toc_wrap {
    .height58,
    .height57 {
      position: relative;
      left: -2px;
    }
  }
  &.tob_wrap {
    .item_name {
      span {
        margin-left: 8px;
        color: #000;
        font-family: PingFang SC;
        font-size: 14px;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
  &.dl_wrap {
    margin-top: 0;
    .item_name {
      // padding: 10px 10px 10px 0;
      span {
        margin-left: 8px;
      }
    }
  }
}
/deep/ .van-overlay {
  top: 45px;
}
.mentionboad {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.gotoLogin {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 72px;
  background: #FFF;
  box-sizing: border-box;
  padding-top: 10px;
  .button-wrap {
    width: 335px;
    height: 42px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border: 1px solid #EEEFF0;
    color: #0070F9;
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    margin: 0 auto;
  }
}
</style>
